import { Logo } from '@/components/Icon/Logo';
import { theme } from '@/theme';
import React, { FunctionComponent } from 'react';

type AgoraLogoProps = {
  onClick: () => void;
  isWhiteNavbar: boolean;
};

export const AgoraLogo: FunctionComponent<AgoraLogoProps> = ({ onClick, isWhiteNavbar }) => (
  <button onClick={onClick}>
    <Logo
      type="horizontal"
      width="130px"
      height="80px"
      color={isWhiteNavbar ? theme.colors.black : theme.colors.white}
    />
  </button>
);
